import { render, staticRenderFns } from "./StaffPayoutsError.vue?vue&type=template&id=25619e72&"
import script from "./StaffPayoutsError.vue?vue&type=script&lang=js&"
export * from "./StaffPayoutsError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports